import { render, staticRenderFns } from "./ComponentTable.vue?vue&type=template&id=55441a46&scoped=true"
import script from "./ComponentTable.vue?vue&type=script&lang=js"
export * from "./ComponentTable.vue?vue&type=script&lang=js"
import style0 from "./ComponentTable.vue?vue&type=style&index=0&id=55441a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55441a46",
  null
  
)

export default component.exports